export default "/048cb1f2b29308e18768c65cfd51e426596a830c/63be6d886170d40a9f7900a9c2ee1f30.png";